import React, { useState } from 'react';
import Checkbox from '../../shared/Checkbox';

function Features({ features, selectedFeatures = [], onFeatureChange }) {
  const [currentFeatures, setCurrentFeatures] = useState(selectedFeatures)

  const handleFeatureChange = (feature) => {
    const updatedFeatures = currentFeatures.includes(feature)
      ? currentFeatures.filter((pref) => pref !== feature)
      : [...currentFeatures, feature];

    setCurrentFeatures(updatedFeatures);
    onFeatureChange(updatedFeatures);
  };

  return (
    <div className="bg-gray-50 p-5 rounded-xl border border-gray-200 h-full">
      <h3 className="text-lg font-bold text-rd-navy mb-4 flex items-center">
        <span className="text-2xl mr-2">⚒️</span>
        Funcionalidades
      </h3>
      <ul className="space-y-3">
        {features.map((feature, index) => (
          <li key={index} className="transition-all duration-200 hover:translate-x-1">
            <Checkbox
              value={feature}
              checked={currentFeatures.includes(feature)}
              onChange={() => handleFeatureChange(feature)}
              className="text-rd-cyan"
            >
              {feature}
            </Checkbox>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Features;
